import { Component } from '@angular/core';

@Component({
	selector: 'gp-angular-redirect',
	templateUrl: './redirect.component.html'
})
export class RedirectComponent {
}
